export default {"src":"/_next/static/media/flower.d5a2ff3a.svg","height":63,"width":50};